// AnimatedSection.tsx
import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

interface AnimatedSectionProps {
  children: React.ReactNode;
  animation?: string;
  delay?: number;
  id?: string;
}

const AnimatedSection = ({ 
  children, 
  animation = 'fadeIn', 
  delay = 0,
  id
}: AnimatedSectionProps) => { 

  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const getAnimationClasses = () => {
    switch(animation) {
      case 'fadeIn':
        return 'opacity-0 transition-all duration-700 ease-out';
      case 'slideLeft':
        return 'opacity-0 translate-x-10 transition-all duration-700 ease-out';
      case 'slideRight':
        return 'opacity-0 -translate-x-10 transition-all duration-700 ease-out';
      case 'slideUp':
        return 'opacity-0 translate-y-10 transition-all duration-700 ease-out';
      case 'zoomIn':
        return 'opacity-0 scale-95 transition-all duration-700 ease-out';
      case 'staggerFadeIn':
        return 'opacity-0 transition-all duration-700 ease-out';
      default:
        return 'opacity-0 transition-all duration-700 ease-out';
    }
  };

  return (
    <section 
      id={id}
      ref={ref}
      className={`${getAnimationClasses()} ${inView ? 'opacity-100 translate-x-0 translate-y-0 scale-100' : ''}`}
      style={{
        transitionDelay: inView ? `${delay}ms` : '0ms',
        willChange: 'transform, opacity'
      }}
    >
      {children}
    </section>
  );
};

export default AnimatedSection;